import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable import/order */
import React, { Component } from 'react';
import { defaultMemoize } from 'reselect';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import _uniq from 'lodash/uniq';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import _difference from 'lodash/difference';
import _without from 'lodash/without';
import _property from 'lodash/property';
import _isFunction from 'lodash/isFunction';
import _findIndex from 'lodash/findIndex';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { DEFAULT_ROW_HEIGHT, BASE_CHECKBOX_COLUM, KEYBOARD_EVENTS } from './withCheckboxTable.constants';

// Component
import CheckboxRenderer from '../../molecules/CellRenderers/CheckboxRenderer';

// Helpers
import { makeGetTrProps } from '../../molecules/table/helpers/rowHelpers';
import { isAllSelected, isIndeterminate, getTableDataIds, getSelectedIdSet, getIndeterminateSet, getValidSelectedIdsBetweenIndices, isShiftKey } from './withCheckboxTable.helper';

// Styles
import COLORS from '@tekion/tekion-styles-next/scss/variables.scss';
import s from './withCheckboxTable.module.scss';
var withCheckboxTable = function withCheckboxTable(TableComponent) {
  var WithCheckboxTable = /*#__PURE__*/function (_Component) {
    _inherits(WithCheckboxTable, _Component);
    var _super = _createSuper(WithCheckboxTable);
    function WithCheckboxTable(props) {
      var _this;
      _classCallCheck(this, WithCheckboxTable);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "getTableDataIds", defaultMemoize(getTableDataIds));
      _defineProperty(_assertThisInitialized(_this), "getSelectedIdSet", defaultMemoize(getSelectedIdSet));
      _defineProperty(_assertThisInitialized(_this), "getIndeterminateSet", defaultMemoize(getIndeterminateSet));
      _defineProperty(_assertThisInitialized(_this), "isAllSelected", defaultMemoize(isAllSelected));
      _defineProperty(_assertThisInitialized(_this), "isIndeterminate", defaultMemoize(isIndeterminate));
      _defineProperty(_assertThisInitialized(_this), "getValidSelectedIdsBetweenIndices", defaultMemoize(getValidSelectedIdsBetweenIndices));
      // eslint-disable-next-line react/sort-comp
      _defineProperty(_assertThisInitialized(_this), "getColumnsWithCheckbox", function (columns, checkboxColumnOverrides) {
        var checkboxColumn = _objectSpread(_objectSpread(_objectSpread({}, BASE_CHECKBOX_COLUM), checkboxColumnOverrides), {}, {
          Cell: _this.renderCell,
          Header: _this.renderHeader,
          frozen: 'left'
        });
        return [checkboxColumn].concat(_toConsumableArray(columns));
      });
      _defineProperty(_assertThisInitialized(_this), "getColumns", defaultMemoize(_this.getColumnsWithCheckbox));
      _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
        var shiftKeyMultiSelectionEnabled = _this.props.shiftKeyMultiSelectionEnabled;
        if (shiftKeyMultiSelectionEnabled) {
          _this.attachEventListeners();
        }
      });
      _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
        var shiftKeyMultiSelectionEnabled = _this.props.shiftKeyMultiSelectionEnabled;
        if (shiftKeyMultiSelectionEnabled) {
          _this.detachEventListeners();
        }
      });
      _defineProperty(_assertThisInitialized(_this), "attachEventListeners", function () {
        document.addEventListener(KEYBOARD_EVENTS.KEY_UP, _this.handleKeyUp);
        document.addEventListener(KEYBOARD_EVENTS.KEY_DOWN, _this.handleKeyDown);
      });
      _defineProperty(_assertThisInitialized(_this), "detachEventListeners", function () {
        document.removeEventListener(KEYBOARD_EVENTS.KEY_UP, _this.handleKeyUp);
        document.removeEventListener(KEYBOARD_EVENTS.KEY_DOWN, _this.handleKeyDown);
      });
      _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (e) {
        var isShiftDown = _this.state.isShiftDown;
        if (isShiftKey(e) && isShiftDown) {
          _this.setState({
            isShiftDown: false,
            selectIndex: -1
          });
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
        var isShiftDown = _this.state.isShiftDown;
        if (isShiftKey(e) && !isShiftDown) {
          _this.setState({
            isShiftDown: true
          });
        }
      });
      _defineProperty(_assertThisInitialized(_this), "getRowProps", function (_, rowInfo) {
        var _this$props = _this.props,
          rowHeight = _this$props.rowHeight,
          rowStyle = _this$props.rowStyle,
          getId = _this$props.getId,
          selection = _this$props.selection;
        var original = _get(rowInfo, 'original');
        var id = getId(original);
        var selectedIdSet = _this.getSelectedIdSet(selection);
        var backgroundColor = selectedIdSet.has(id) ? COLORS.aliceBlue : COLORS.white;
        return {
          style: _objectSpread(_objectSpread({}, rowStyle), {}, {
            height: rowHeight,
            backgroundColor: backgroundColor
          })
        };
      });
      _defineProperty(_assertThisInitialized(_this), "handleToggleAll", function (checked) {
        var _this$props2 = _this.props,
          onSelect = _this$props2.onSelect,
          selection = _this$props2.selection,
          getId = _this$props2.getId,
          data = _this$props2.data;
        var tableDataIds = _this.getTableDataIds(data, getId);
        if (checked) {
          var _updatedSelection = _uniq([].concat(_toConsumableArray(selection), _toConsumableArray(tableDataIds)));
          return onSelect(_updatedSelection);
        }
        var updatedSelection = _without.apply(void 0, [selection].concat(_toConsumableArray(tableDataIds)));
        return onSelect(updatedSelection);
      });
      _defineProperty(_assertThisInitialized(_this), "handleToggleSelection", function (checked, rowData) {
        var _this$props3 = _this.props,
          onSelect = _this$props3.onSelect,
          selection = _this$props3.selection,
          getId = _this$props3.getId,
          data = _this$props3.data,
          disabled = _this$props3.disabled;
        var _this$state = _this.state,
          isShiftDown = _this$state.isShiftDown,
          selectIndex = _this$state.selectIndex;
        var id = getId(rowData);
        var currentSelectionIndex = _findIndex(data, function (eachData) {
          return id === getId(eachData);
        });
        if (checked) {
          var inBetweenIds = [];
          if (isShiftDown) {
            if (currentSelectionIndex > selectIndex) {
              // rows after selectIndex is checked
              // pick all ids between selectIndex and currentSelectionIndex
              inBetweenIds = _this.getValidSelectedIdsBetweenIndices(data, selectIndex + 1, currentSelectionIndex, getId, disabled);
            } else if (currentSelectionIndex < selectIndex) {
              // pick all ids between currentSelectionIndex and selectIndex
              inBetweenIds = _this.getValidSelectedIdsBetweenIndices(data, currentSelectionIndex, selectIndex + 1, getId, disabled);
            }
          }
          var _updatedSelection2 = [].concat(_toConsumableArray(selection), [id], _toConsumableArray(inBetweenIds));
          _this.setState({
            selectIndex: currentSelectionIndex
          });
          return onSelect(_updatedSelection2);
        }
        var updatedSelection = _without(selection, id);
        return onSelect(updatedSelection);
      });
      _defineProperty(_assertThisInitialized(_this), "renderHeader", function (headerProps) {
        var _this$props4 = _this.props,
          data = _this$props4.data,
          selection = _this$props4.selection,
          getId = _this$props4.getId,
          disabled = _this$props4.disabled,
          canDisableHeaderCheckbox = _this$props4.canDisableHeaderCheckbox,
          indeterminateIds = _this$props4.indeterminate,
          checkboxHeaderClassName = _this$props4.checkboxHeaderClassName,
          noHeadSelector = _this$props4.noHeadSelector;
        if (noHeadSelector) return null;
        var tableDataIds = _this.getTableDataIds(data, getId);
        var selectedIdSet = _this.getSelectedIdSet(selection);
        var indeterminateIdSet = _this.getIndeterminateSet(indeterminateIds);
        var checked = _this.isAllSelected(tableDataIds, selectedIdSet);
        var indeterminate = _this.isIndeterminate(tableDataIds, selectedIdSet, indeterminateIdSet);
        return /*#__PURE__*/React.createElement(CheckboxRenderer, _extends({}, headerProps, {
          checked: checked,
          disabled: canDisableHeaderCheckbox && _isEmpty(_difference(tableDataIds, disabled)),
          indeterminate: indeterminate,
          onClick: _this.handleToggleAll,
          className: checkboxHeaderClassName
        }));
      });
      _defineProperty(_assertThisInitialized(_this), "renderCell", function (cellProps) {
        var _this$props5 = _this.props,
          selection = _this$props5.selection,
          getId = _this$props5.getId,
          disabled = _this$props5.disabled,
          indeterminateIds = _this$props5.indeterminate;
        var rowData = _get(cellProps, 'original');
        var id = getId(rowData);
        var getShouldShowRowSelect = _get(rowData, 'getShouldShowRowSelect');
        // adding this to conditionally render the checkbox for a row.
        // passing cell props to the shouldShowRowSelect function
        // so that we can make decisions based on the row data.
        // render the checkbox if shouldShowRowSelect is not passed.
        var shouldShowRowSelect = _isFunction(getShouldShowRowSelect) ? getShouldShowRowSelect(cellProps) : true;
        var selectedIdSet = _this.getSelectedIdSet(selection);
        var indeterminateIdSet = _this.getIndeterminateSet(indeterminateIds);
        var isDisabled = _includes(disabled, id);
        var checked = selectedIdSet.has(id);
        var isCellIndeterminate = indeterminateIdSet.has(id);
        if (!shouldShowRowSelect) return null;
        return /*#__PURE__*/React.createElement(CheckboxRenderer, _extends({}, cellProps, {
          checked: checked,
          indeterminate: isCellIndeterminate,
          disabled: isDisabled,
          className: "full-width full-height flex-center",
          onClick: _this.handleToggleSelection
        }));
      });
      var getTrProps = _this.props.getTrProps;
      _this.checkBoxTable = /*#__PURE__*/React.createRef();
      _this.getTrProps = makeGetTrProps(getTrProps, _this.getRowProps);
      _this.state = {
        isShiftDown: false,
        selectIndex: -1
      };
      return _this;
    }
    _createClass(WithCheckboxTable, [{
      key: "render",
      value: function render() {
        var _this$props6 = this.props,
          columns = _this$props6.columns,
          checkboxColumnOverrides = _this$props6.checkboxColumnOverrides,
          className = _this$props6.className;
        var columnsWithCheckbox = this.getColumns(columns, checkboxColumnOverrides);
        return /*#__PURE__*/React.createElement(TableComponent, _extends({}, this.props, {
          className: "".concat(className, " ").concat(s.checkboxTableContainer),
          ref: this.checkBoxTable,
          getTrProps: this.getTrProps,
          columns: columnsWithCheckbox
        }));
      }
    }]);
    return WithCheckboxTable;
  }(Component);
  WithCheckboxTable.propTypes = {
    data: PropTypes.array,
    selection: PropTypes.array,
    indeterminate: PropTypes.array,
    disabled: PropTypes.array,
    columns: PropTypes.array.isRequired,
    checkboxColumnOverrides: PropTypes.object,
    getId: PropTypes.func,
    getTrProps: PropTypes.func,
    onSelect: PropTypes.func,
    className: PropTypes.string,
    rowHeight: PropTypes.number,
    rowStyle: PropTypes.object,
    canDisableHeaderCheckbox: PropTypes.bool,
    checkboxHeaderClassName: PropTypes.string,
    shiftKeyMultiSelectionEnabled: PropTypes.bool,
    noHeadSelector: PropTypes.bool
  };
  WithCheckboxTable.defaultProps = {
    data: EMPTY_ARRAY,
    selection: EMPTY_ARRAY,
    indeterminate: EMPTY_ARRAY,
    disabled: EMPTY_ARRAY,
    checkboxColumnOverrides: EMPTY_OBJECT,
    getId: _property('id'),
    getTrProps: _noop,
    onSelect: _noop,
    className: '',
    rowHeight: DEFAULT_ROW_HEIGHT,
    rowStyle: EMPTY_OBJECT,
    canDisableHeaderCheckbox: false,
    checkboxHeaderClassName: undefined,
    shiftKeyMultiSelectionEnabled: false,
    noHeadSelector: false
  };
  return WithCheckboxTable;
};
export default withCheckboxTable;